import { Button, TextField, styled, Typography } from "@material-ui/core";

export const CustomHeading = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.down("xs")]: {
    fontSize: "2.4rem",
    lineHeight: "3rem"
  }
}));

export const CustomVideo = styled("video")(() => ({
  width: "100%",
  height: "auto !important",
  outline: "0 !important",
  overflow: "hidden !important"
}));
